import { render } from "./HomeDashboard.vue?vue&type=template&id=2f90da1d&scoped=true&ts=true"
import script from "./HomeDashboard.vue?vue&type=script&lang=ts"
export * from "./HomeDashboard.vue?vue&type=script&lang=ts"

import "./HomeDashboard.vue?vue&type=style&index=0&id=2f90da1d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f90da1d"]])

export default __exports__